












































































































































































































import debounce from 'lodash/debounce';

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';
import { validationMixin } from 'vuelidate'
import { required, requiredIf, minLength, sameAs } from 'vuelidate/lib/validators'
import Attachments from '@/components/Controls/Attachments.vue';

import { getFieldError } from '@/core/tools/forms/get_field_error';

import { STORE_KEY, store } from './_store';

@Component({
  mixins: [ validationMixin ],
  computed: {
    ...mapState(STORE_KEY, [
      'loaded', 'loading', 'fatalError',
      'document', 'form', 'meta', 'ingredients'
    ]),
    ...mapGetters(STORE_KEY, [
      'fields'
    ])
  },
  methods: {
    getFieldError
  },
  validations() {
    const rules: any = {
      base_id: { required },
      total_weight: {required},
      datetime: {required},
      close_date: {},
      type: {},
    }

    return {
      form: rules
    }
  },
  components: {
    Attachments
  }
})
export default class PrescriptManagerForm extends Vue {
  @Prop({ type: Boolean }) isNew!: boolean;
  @Prop({ type: Object }) documentPreview!: any;
  @Prop({ type: Object }) initParams!: any;

  document!: any
  form!: any

  public isSuggestionsFetching = false;
  public suggestions: any[] = [];

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    if (this.isNew) {
      this.$store.dispatch(`${STORE_KEY}/prepareNew`, this.initParams);
    } else {
      this.$store.dispatch(`${STORE_KEY}/init`, {
        id: this.documentPreview.id
      });
    }
  }

  addAttachments(file: any) {
    this.$store.dispatch(`${STORE_KEY}/addAttachments`, file);
  }

  removeFile( idx: number, data: any) {
    this.form.attachments.splice(idx, 1)
  }

  setArchive() {
    this.$store.dispatch(`${STORE_KEY}/setArchive`)
    .then((result) => {
        this.$buefy.snackbar.open(`Записть архивирована`);

        this.$emit('form-close');
        (this.$parent as any).close();
      })
      .catch((e: any) => {
        console.log(e)
        this.$buefy.snackbar.open({
          type: 'is-warning',
          message: `При сохранении возникли проблемы. Попробуйте позже.`
        })
      })
  }

  setUnarchive() {
    this.$store.dispatch(`${STORE_KEY}/setUnarchive`)
    .then((result) => {
        this.$buefy.snackbar.open(`Записть активирована`);

        this.$emit('form-close');
        (this.$parent as any).close();
      })
      .catch((e) => {
        console.log(e)
        this.$buefy.snackbar.open({
          type: 'is-warning',
          message: `При сохранении возникли проблемы. Попробуйте позже.`
        })
      })    
  }

  changeValue(field: string, value: any) {
    this.$store.dispatch(`${STORE_KEY}/changeFormValue`, {
      field, newValue: value
    });

    if (this.$v.form[field]) {
      // @ts-ignore
      this.$v.form[field].$touch();
    }
  }
  changeIngredientValue(idx: number, field: any, $event: any) {
    this.$store.dispatch(`${STORE_KEY}/changeIngredientValue`, {
      idx, field, newValue: $event
    });
  }
  addIngredient() {
    this.$store.dispatch(`${STORE_KEY}/addIngredient`);
  }

  copyIngredient(idx: number) {
    this.$store.dispatch(`${STORE_KEY}/copyIngredient`, {idx});
  }

  delIngredient(idx: number) {
    this.$store.dispatch(`${STORE_KEY}/delIngredient`, {idx});
  }

  changeIngredientObject(index: number, ingredient: any) {
    this.changeIngredientValue(index, 'protein_percent', ingredient.protein)
    this.changeIngredientValue(index, 'fats_percent', ingredient.fats)
    this.changeIngredientValue(index, 'carbohydrate_percent', ingredient.carbohydrate)
    console.log(ingredient)
  }

  saveFormData() {
    this.$v.form.$touch()

    if(!this.$v.form.$error) {
      this.$store.dispatch(`${STORE_KEY}/saveForm`, this.documentPreview ? this.documentPreview.id : null)
      .then((result) => {
        this.$buefy.snackbar.open(`Данные успешно сохранены`);
        this.$v.form.$reset();

        this.$emit('form-close');
        (this.$parent as any).close();
      })
      .catch(() => {
        this.$buefy.snackbar.open({
          type: 'is-warning',
          message: `При сохранении возникли проблемы. Попробуйте позже.`
        })
      })
    }

  }

  beforeDestroy() {
    this.$store.dispatch(`${STORE_KEY}/reset`);
    // this.$store.unregisterModule(STORE_KEY);
  }
}

